import { apiClient } from "@/services/api";
import { safeArray } from "../utils";
import type { AlarmListResponse, AlarmListResult } from "../types";

const GENIE_ID = "genie1";
export const eventService = {
  getLiveEvents: async (
    taskId: string,
    pageNo: number = 1,
  ): Promise<AlarmListResult> => {
    if (!taskId) throw new Error("taskId is required");

    const { data } = await apiClient.post<AlarmListResponse>(
      `/events/${GENIE_ID}/live`,
      { taskId, pageNo },
    );

    if (!data || typeof data !== "object") {
      throw new Error("Invalid response from server");
    }

    if (data.code !== 0) {
      throw new Error(data.msg || "Failed to fetch events");
    }

    const result = data.result ?? {};
    return {
      items: safeArray(result.items),
      maxSize: result.maxSize ?? "",
      pageCount: result.pageCount ?? 1,
      pageNo: result.pageNo ?? pageNo,
      pageSize: result.pageSize ?? 20,
      total: result.total ?? 0,
      usedSize: result.usedSize ?? "",
    };
  },
};
